import { render, staticRenderFns } from "./recent27.vue?vue&type=template&id=76c65e5c&scoped=true&"
import script from "./recent27.vue?vue&type=script&lang=js&"
export * from "./recent27.vue?vue&type=script&lang=js&"
import style0 from "./recent27.vue?vue&type=style&index=0&id=76c65e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c65e5c",
  null
  
)

export default component.exports